<app-content-shell>
  <app-header mainHeader />

  <app-panel-header panelHeader [title]="'General Settings'" />

  <div panelContent>
    @for (item of settingsItems; track item.id) {
      <app-list-item [selected]="selectedItem === item.id" (click)="selectItem(item.id)">
        <span itemTitle>{{ item.label }}</span>
      </app-list-item>
    }
  </div>

  <div mainContent class="app-settings-main full-height-content">
    @switch (selectedItem) {
      @case ('countries') {
        <app-countries-allowed />
      }
      @case ('vocabulary') {
        <app-global-vocabulary-rules />
      }
      @case ('instructions') {
        <app-global-instructions />
      }
      @case ('dashboard') {
        <app-dashboard-content />
      }
      @case ('login-notice') {
        <app-login-notice />
      }
      @case ('version') {
        <app-version />
      }
      @case ('login-popup') {
        <app-login-popup />
      }
      @case ('exit-survey') {
        <app-exit-survey />
      }
      @case ('bot-ui-config') {
        <app-bot-ui-config-settings />
      }
      @case ('reference-stream-mode') {
        <app-reference-stream-mode />
      }
      @case ('reference-citation-display') {
        <app-reference-citation-display />
      }
    }
  </div>
</app-content-shell>
